// API Endpoints Configuration
// ปรับแต่งได้จากที่เดียว สำหรับ URL และ Logic ทั้งหมด

// ===== 🎯 เลือก API ที่จะใช้งาน =====
// เปลี่ยนค่านี้เพื่อสลับ API ทั้งระบบ:
// - 'OLD_API' = content-delivery-api.manonsanoi.workers.dev (API เดิม)
// - 'NEW_API' = content.cloudrestfulapi.com (API ใหม่)

const ACTIVE_API = 'NEW_API'  // 👈 เปลี่ยนตรงนี้

// ===== 📋 API Configurations =====
const API_CONFIGS = {
  OLD_API: {
    baseUrl: 'https://content-delivery-api.manonsanoi.workers.dev',
    patterns: [
      'content-delivery-api.manonsanoi.workers.dev',
      'content-delivery-api',
      'manonsanoi.workers.dev'
    ],
    regexPatterns: [
      /content-delivery-api.*stream/i,
      /manonsanoi\.workers\.dev/i,
      /content-delivery-api/i
    ]
  },
  
  NEW_API: {
    baseUrl: 'https://content.cloudrestfulapi.com',
    patterns: [
      'content.cloudrestfulapi.com',
      'streaming.origins.observer'
    ],
    regexPatterns: [
      /content\.cloudrestfulapi\.com/i,
      /content\.cloudrestfulapi\.com\/api\/stream/i,
      /streaming\.origins\.observer/i
    ]
  }
}

// Get active configuration
const getActiveConfig = () => API_CONFIGS[ACTIVE_API]

export const API_CONFIG = {
  // Main Content Delivery API (ใช้ configuration ที่เลือก)
  CONTENT_DELIVERY: {
    get baseUrl() { return getActiveConfig().baseUrl },
    get patterns() { return getActiveConfig().patterns },
    get regexPatterns() { return getActiveConfig().regexPatterns },
    
    // API Paths (เหมือนเดิมสำหรับทุก API)
    paths: {
      stream: '/api/stream',
      streamInfo: '/api/stream/{id}/info',
      streamCheck: '/api/stream/{id}'
    }
  },
  
  // Static Video ID (สำหรับทดสอบ)
  DEFAULT_STREAM_ID: '68bf95b2e1ebd077525fdeb9',
  
  // Other APIs (ไม่เปลี่ยนแปลง)
  AI_GATEWAY: 'https://ai-gateway.manonsanoi.workers.dev',
  CONNECTION_GATEWAY: 'https://connection-gateway.manonsanoi.workers.dev',
  
  // Helper Functions
  isContentDeliveryUrl(url) {
    return this.CONTENT_DELIVERY.patterns.some(pattern => url.includes(pattern)) || 
           url.includes(this.DEFAULT_STREAM_ID);
  },
  
  isVideoChunkRequest(url) {
    if (typeof url !== 'string') return false;

    let parsedUrl;
    try {
      parsedUrl = new URL(url);
    } catch {
      return false;
    }

    const allowedHosts = [
      'content.cloudrestfulapi.com',
      'streaming.origins.observer',
      'content-delivery-api.manonsanoi.workers.dev'
    ];

    if (!allowedHosts.includes(parsedUrl.hostname)) {
      return false;
    }
    
    // Check for common video chunk patterns
    const videoChunkPatterns = [
      /\.ts$/i,                          // HLS segments
      /\.m4s$/i,                         // DASH segments
      /segment-\d+/i,                    // Generic segments
      /chunk-\d+/i,                      // Generic chunks
      /range=\d+-\d+/i,                  // Range requests in URL params
      /\/api\/stream\/.*\/\d+$/i,        // API stream chunks
      /streamfile=/i,                    // Stream engine requests
      /\.mp4/i,                          // MP4 files
      /\.webm/i,                         // WebM files
      /\.m3u8/i,                         // HLS playlists
      ...this.CONTENT_DELIVERY.regexPatterns
    ];
    
    return videoChunkPatterns.some(pattern => pattern.test(url)) ||
           url.includes(this.DEFAULT_STREAM_ID);
  },
  
  // Generate full API URLs
  getStreamUrl(streamId, params = {}) {
    const baseUrl = this.CONTENT_DELIVERY.baseUrl;
    const path = this.CONTENT_DELIVERY.paths.stream;
    const queryString = new URLSearchParams(params).toString();
    const separator = queryString ? '?' : '';
    
    return `${baseUrl}${path}/${streamId}${separator}${queryString}`;
  },
  
  getStreamInfoUrl(streamId) {
    const baseUrl = this.CONTENT_DELIVERY.baseUrl;
    const path = this.CONTENT_DELIVERY.paths.streamInfo.replace('{id}', streamId);
    
    return `${baseUrl}${path}`;
  },
  
  getStreamCheckUrl(streamId) {
    const baseUrl = this.CONTENT_DELIVERY.baseUrl;
    const path = this.CONTENT_DELIVERY.paths.streamCheck.replace('{id}', streamId);
    
    return `${baseUrl}${path}`;
  }
}

// Export for easy switching (legacy support)
export const SWITCH_TO_NEW_API = () => {
  console.warn('⚠️ SWITCH_TO_NEW_API is deprecated. Please change ACTIVE_API to "NEW_API" in config/api-endpoints.js')
}

export const SWITCH_TO_OLD_API = () => {
  console.warn('⚠️ SWITCH_TO_OLD_API is deprecated. Please change ACTIVE_API to "OLD_API" in config/api-endpoints.js')
}

// Export current active API info for debugging
export const getCurrentAPI = () => ({
  active: ACTIVE_API,
  baseUrl: getActiveConfig().baseUrl,
  patterns: getActiveConfig().patterns
})

// Helper function to log current API status
export const logCurrentAPI = () => {
  const current = getCurrentAPI()
  console.log(`🔗 Active API: ${current.active}`)
  console.log(`🌐 Base URL: ${current.baseUrl}`)
  console.log(`🎯 Patterns:`, current.patterns)
}

export default API_CONFIG